import * as React from "react";
const Download = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6,13 L5,13 L5,17 C5,18.1045695 5.8954305,19 7,19 L18,19 C19.1045695,19 20,18.1045695 20,17 L20,13 L19,13 L19,17 C19,17.5522847 18.5522847,18 18,18 L7,18 C6.44771525,18 6,17.5522847 6,17 L6,13 Z M16,11.625 L15.5,11 L13,13.5 L13,5 L12,5 L12,13.5 L9.5,11 L9,11.625 L12.5,15 L16,11.625 Z" }));
Download.displayName = "Download";
var Download_default = Download;
export {
  Download_default as default
};
